<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-book"></i></div>
      <div>
        Suivi des contenus de cours
        <div class="page-title-subheading">Gestion du cahier de texte</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
              
                <div class="card-body">
                      <div class="d-flex justify-content-between mb-5">
         
                        <div class="w-50">
                            <input type="date" (change)="reload($event)" id="">
                        </div>
                    
                    <div class="form-group ms-auto">
                        <label for="search_text" class="form-label mb-0"><strong>Rechercher</strong></label>
                        <input id="search_text" type="text" name="search_text" class="form-control form-control-sm"
                               placeholder="Rechercher..." [(ngModel)]="search_text">
                    </div>
                </div>
    
                            <p>{{data!.length}} élément(s)</p>
                            <div class="table-responsive">
                            <table class="table" >
                                <thead class="">
                                    <tr>
                                        <th style="width: 10px;">#</th>
                                        <th>Date de saisie</th>
                                        <th>Enseignant</th>
                                        <th>Matière</th>
                                        <th>Titre</th>
                                        <th>Contenu</th>
                                        <th>Devoir de maison</th>
                                        <th>Document Joint</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'periods' | paginate: {
                                    id:'ngxP1',
                                    itemsPerPage: pg.pageSize,
                                    currentPage: pg.p,
                                    totalItems: pg.total } ">
                                        <td>
                                            <div class="form-check mb-2">
                                                <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                            
                                            </div>
                                        </td>
                                        <td>{{d.created_at | date:"dd-MM-yyyy HH:mm:ss"}}</td>
                                        <td>{{d.pacc?.pac?.professor?.lastname}} {{d.pacc?.pac?.professor?.lastname}}</td>
                                        <td>{{d.pacc?.course?.name}}</td>
                                        <td>{{d.title}}</td>
                                        <td>{{d.content}}</td>
                                        <td>{{d.tasks.length}}</td>
                                        <td>
                                            <span class="text-primary" *ngIf="d.filename == null">Non</span>
                                        </td>
                                    </tr>
                                
                                </tbody>
                            </table>
                            </div>
                              <pagination-controls 
                            id="ngxP1"
                            (pageChange)="getPage($event)"
                          [maxSize]="9"
                          [directionLinks]="true"
                          [autoHide]="true"
                          [responsive]="true"
                          [previousLabel]="'Précédent'"
                          [nextLabel]="'Suivant'"
                          [screenReaderPaginationLabel]="'Pagination'"
                          [screenReaderPageLabel]="'page'"
                          [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                         </pagination-controls>
    
                </div><!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end col -->
    </div>



<ng-template #contentPDF let-offcanvas>
    <div class="offcanvas-header">
      
      <h4 class="offcanvas-title">Visualiseur de fichier</h4>
      <button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
    </div>
    <div class="offcanvas-body">
          <ngx-extended-pdf-viewer [src]="pdfSrc"
          style="width: 100%; height: 100%"
          ></ngx-extended-pdf-viewer>
    </div>
  </ng-template>
